export { FinancialResultsReport } from '@app/pages/Analytics/FinancialResultsReport/ui';
